import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import CcRenameModal from '@/views/Automation/CampaignCreatorV2/components/Modals/CcRenameModal.ts.vue';
import { Icons } from '@/views/Automation/CampaignCreatorV2/helpers/icons';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { ref } from 'vue';

interface Action {
  icon: Icons;
  type?: string;
  text?: string;
  fillIcon?: boolean;
}

interface Props {
  title?: string;
  info?: string;
  layer?: CardLayer;
  action?: Action;
  editTitle?: boolean;
}

interface Emits {
  (e: 'update', value: string): void;
  (e: 'action', value?: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcCardItem.ts',
  props: {
    title: { default: '' },
    info: { default: '' },
    layer: { default: CardLayer.LAYER_0 },
    action: null,
    editTitle: { type: Boolean, default: false }
  },
  emits: ["update", "action"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update', value: string): void;
  (e: 'action', value?: string): void;
}), expose: any, slots: any, attrs: any }) {





const isModalOpened = ref(false);

const onTitleChange = (newTitle: string) => {
  emits('update', newTitle);
  isModalOpened.value = false;
};

return { __sfc: true,emits, isModalOpened, onTitleChange, CcIcon, CcRenameModal }
}

})